/**
 * changeLieferantSettings
 * @param element
 * @param dataUserLieferantID
 * @param verkaeuferCode
 */
window.changeLieferantSettings = function (element, dataUserLieferantID, verkaeuferCode) {
    $.ajax({
        url: BASE_PATH + 'ajax/helper/lager/ajax.setLagerUserLieferanten',
        type: 'post',
        data: {
            uid: dataUserLieferantID,
            key: $(element).attr('name'),
            value: ($(element).is(':checked') ? 1 : 0),
            lieferantID: verkaeuferCode
        }
    });
};